// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federnormen/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federnormenDE: PageEntry = {
  id: "post.federnormen",
  locale: "de",
  slug: "federnormen",
  seo: {
    title: "Glossar: Federnormen einfach erklärt | Dietz GmbH",
    description: "Federnormen sind standardisierte Richtlinien und Spezifikationen, die die Herstellung, Qualität und Anwendung von Federn regeln. Diese Normen werden von internationalen Organisatio",
  },
  type: "post",
  h1: "Glossar: Federnormen einfach erklärt",
  intro: "Federnormen sind standardisierte Richtlinien und Spezifikationen, die die Herstellung, Qualität und Anwendung von Federn regeln. Diese Normen werden von internationalen Organisationen wie der ISO (International Organization for Standardization) oder nationalen Normungsstellen festgelegt. Sie umfassen Parameter wie Materialeigenschaften, Federabmessungen, Belastungsanforderungen und Prüfverfahren. Die Einhaltung von Federnormen ist entscheidend, um die Interoperabilität, Sicherheit und Qualität von Federn in verschiedenen Industriezweigen sicherzustellen.",
  blocks: [

  ],
};
